"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CnReadonly = CnReadonly;
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _ellipsis = require("../ellipsis");
require("./index.scss");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function addKey(e, key) {
  if ( /*#__PURE__*/React.isValidElement(e)) {
    return /*#__PURE__*/React.cloneElement(e, {
      key: key
    });
  }
  return e;
}
function CnReadonly(_ref) {
  var _cx;
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    className = _ref.className,
    value = _ref.value,
    _ref$valueSeperator = _ref.valueSeperator,
    valueSeperator = _ref$valueSeperator === void 0 ? ',' : _ref$valueSeperator,
    _ref$line = _ref.line,
    line = _ref$line === void 0 ? 3 : _ref$line,
    _ref$showFolder = _ref.showFolder,
    showFolder = _ref$showFolder === void 0 ? false : _ref$showFolder,
    _ref$arrowDown = _ref.arrowDown,
    arrowDown = _ref$arrowDown === void 0 ? '' : _ref$arrowDown,
    _ref$arrowUp = _ref.arrowUp,
    arrowUp = _ref$arrowUp === void 0 ? '' : _ref$arrowUp,
    readonlyRender = _ref.readonlyRender;
  var classes = (0, _classnames["default"])((_cx = {
    'cn-ui-readonly': true
  }, _cx[className] = !!className, _cx));
  if (readonlyRender && (0, _isFunction["default"])(readonlyRender)) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes,
      style: style
    }, readonlyRender(value));
  }
  var arrayValue = Array.isArray(value) ? value.map(function (i) {
    return typeof i === 'object' ? (i === null || i === void 0 ? void 0 : i.label) || (i === null || i === void 0 ? void 0 : i.value) : i;
  }) : [typeof value === 'object' ? (value === null || value === void 0 ? void 0 : value.label) || (value === null || value === void 0 ? void 0 : value.value) : value];
  var showValue = arrayValue.reduce(function (p, v, idx) {
    return [].concat(p, [idx === 0 ? '' : addKey(valueSeperator, "x_" + idx), addKey(v, idx)]);
  }, []).filter(function (o) {
    return o;
  });
  return /*#__PURE__*/React.createElement(_ellipsis.CnTextEllipsis, {
    className: classes,
    line: line,
    showTooltip: true,
    showFolder: showFolder,
    arrowUp: arrowUp,
    arrowDown: arrowDown
  }, showValue);
}